import React, { useEffect } from "react";
import type { FC } from "react";

import { Box } from "native-base";
import { useQueryLoader } from "react-relay";

import InvoiceAndEmail from "pianofunclub-crm/components/Invoicing/InvoiceAndEmail";
import type {
  AccountsStackNavigatorProps,
  AccountsStackRouteProps,
} from "pianofunclub-crm/navigation/AccountsNavigator";
import type {
  InvoicingStackNavigatorProps,
  InvoicingStackRouteProps,
} from "pianofunclub-crm/navigation/InvoicingNavigator";
import type {
  PayrollStackNavigatorProps,
  PayrollStackRouteProps,
} from "pianofunclub-crm/navigation/PayrollNavigator";
import type {
  RegistersStackNavigatorProps,
  RegistersStackRouteProps,
} from "pianofunclub-crm/navigation/RegistersNavigator";
import type {
  SchoolsStackNavigatorProps,
  SchoolsStackRouteProps,
} from "pianofunclub-crm/navigation/SchoolsNavigator";
import type {
  WaitingListStackNavigatorProps,
  WaitingListStackRouteProps,
} from "pianofunclub-crm/navigation/WaitingListNavigator";

import type { LoadInvoiceQuery } from "pianofunclub-shared/relay/graphql/invoicing/__generated__/LoadInvoiceQuery.graphql";
import { load_invoice } from "pianofunclub-shared/relay/graphql/invoicing/LoadInvoice";

export type NavigationProps = AccountsStackNavigatorProps<"Invoice"> &
  InvoicingStackNavigatorProps<"Invoice"> &
  SchoolsStackNavigatorProps<"Invoice"> &
  RegistersStackNavigatorProps<"Invoice"> &
  WaitingListStackNavigatorProps<"Invoice"> &
  PayrollStackNavigatorProps<"Invoice">;

export type RouteProps = AccountsStackRouteProps<"Invoice"> &
  InvoicingStackRouteProps<"Invoice"> &
  SchoolsStackRouteProps<"Invoice"> &
  RegistersStackRouteProps<"Invoice"> &
  WaitingListStackRouteProps<"Invoice"> &
  PayrollStackRouteProps<"Invoice">;

interface ScreenProps {
  navigation: NavigationProps;
  route: RouteProps;
}

const InvoiceScreen: FC<ScreenProps> = (props) => {
  const { navigation, route } = props;

  const [loadInvoiceQueryReference, loadInvoiceQuery] =
    useQueryLoader<LoadInvoiceQuery>(load_invoice);

  useEffect(() => {
    loadInvoiceQuery(
      {
        invoiceId: route.params?.invoiceId,
        skip: false,
      },
      { fetchPolicy: "store-or-network" }
    );
  }, [loadInvoiceQuery, route.params?.invoiceId]);

  return (
    <Box bg="surface.100" flex={1}>
      <InvoiceAndEmail
        isEditable
        loadInvoiceQuery={loadInvoiceQuery}
        loadInvoiceQueryReference={loadInvoiceQueryReference}
        // @ts-expect-error nav props are merged on component
        navigation={navigation}
        previousOtherInvoicesConnectionIds={route.params.previousOtherInvoicesConnectionIds}
        route={route}
      />
    </Box>
  );
};

export const screenOptions = {
  headerTitle: "Invoice",
};

export default InvoiceScreen;
